module.exports = __webpack_public_path__ + "media/fundraising_sim/plus_img01-57e91e82.png";